

// Global base URL for your API
export const BASE_URLL = "https://adminnanda.in/Job/";

